module.exports = __webpack_public_path__ + "cfp/index.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Emails/emails/1/index.md
// module id = 1028
// module chunks = 0